import logo from "./logo.svg";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Player from "./pages/Player";
import PlayerSlider from "./pages/player-slider/Player-slider";
import MatchList from "./pages/match-list/MatchList";
import PlayerFunctionalWrapper from "./helpers/PlayerFunctionalWrapper";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Player />} />
        <Route path="/embed/:matchId" element={<MatchList />} />
        <Route path="/embed/player" element={<PlayerFunctionalWrapper />} />
      </Routes>
      {/* <Player></Player> */}
    </div>
  );
}

export default App;
